export const SnapshotLoading = () => {
  return (
    <div className="sparkle-box animate-pulse">
      <div className="grid grid-cols-[130px_auto] border-b border-b-border-subtle h-10 an">
        <span className="flex flex-col justify-center px-4 py-2 ">
          <div className="h-3 w-full bg-bg-subtle rounded-xl"></div>
        </span>
        <span className="flex flex-col justify-center px-4 py-2 border-l border-l-border-subtle ">
          <div className="h-3 w-[50%] bg-bg-subtle rounded-xl"></div>
        </span>
      </div>
      <div className="grid grid-cols-[130px_auto] border-b border-b-border-subtle h-10">
        <span className="flex flex-col justify-center px-4 py-2 ">
          <div className="h-3 w-[85%] bg-bg-subtle rounded-xl"></div>
        </span>
        <span className="flex flex-col justify-center px-4 py-2 border-l border-l-border-subtle ">
          <div className="h-3 w-[80%] bg-bg-subtle rounded-xl"></div>
        </span>
      </div>
      <div className="grid grid-cols-[130px_auto] h-10">
        <span className="flex flex-col justify-center px-4 py-2 ">
          <div className="h-3 w-[95%] bg-bg-subtle rounded-xl"></div>
        </span>
        <span className="flex flex-col justify-center px-4 py-2 border-l border-l-border-subtle ">
          <div className="h-3 w-[75%] bg-bg-subtle rounded-xl"></div>
        </span>
      </div>
    </div>
  );
};
